<!-- Container-fluid starts-->
<div class="container-fluid">
    <!-- <div class="col-sm-12 col-xl-12"> -->
      <div class="card">
        <div class="card-header">
          <h5>{{offer.offerName}}</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-2 col-md-2 col-12 b-r-secondary">
              <div class="ribbon-wrapper">
                <div class="ribbon ribbon-primary">Details</div>
                    <div class="form-group">
                      <label class="col-form-label">Payout $</label>
                      <input class="form-control" type="number" value="{{offer.payout }}" disabled>
                    </div>
                    <div class="form-group">
                      <label class="col-form-label">Type</label><br>
                      <ul>
                        <li><i class="icofont icofont-ui-check"></i>&nbsp;<small>{{offer.offerCategoryname}}</small></li>
                      </ul>
                    </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-12 b-r-secondary">
              <div class="ribbon-wrapper">
                <div class="ribbon ribbon-primary">Targeting</div>
                  <div class="form-group">
                    <i class="flag-icon flag-icon-{{offer.countryalpha2Code | lowercase}}"></i>&nbsp;
                    <label class="col-form-label">Country</label>
                    <input class="form-control" type="text" value="{{offer.countryname}}" disabled>
                  </div>
                  <label class="col-form-label">Devices</label><br>
                  <span *ngFor="let dev of offer.offerDevices">
                      <i class="fa fa-mobile-phone" style="font-size: 2.0em;" name="phone" ngbTooltip="phone" *ngIf="dev.name=='Phone'">&nbsp;</i>
                      <i class="fa fa-tablet" style="font-size: 2.0em;" name="tablet" ngbTooltip="tablet" *ngIf="dev.name=='Tablet'">&nbsp;</i>
                      <i class="fa fa-desktop" style="font-size: 2.0em;" name="desktop" ngbTooltip="desktop" *ngIf="dev.name=='Desktop'">&nbsp;</i>
                      <i class="fa fa-gamepad" style="font-size: 2.0em;" name="game" ngbTooltip="game console" *ngIf="dev.name=='Game console'">&nbsp;</i>
                      <i class="fa fa-film" style="font-size: 2.0em;" name="tv" ngbTooltip="TV" *ngIf="dev.name=='Tv'">&nbsp;</i>
                  </span>
                  <br><br>
                  <div class="form-group">
                    <label class="col-form-label">Operating Systems</label><br>
                      <span *ngFor="let oss of offer.operatingSystems">
                        <ul>
                          <li><i class="icofont icofont-gears"></i>&nbsp;<small>{{oss}}</small></li>
                        </ul>
                      </span>
                  </div>
              </div>
            </div>

            <div class="col-lg-7 col-md-7 col-12">
              <div class="ribbon-wrapper">
                <div class="ribbon ribbon-primary">Tracking link</div>
                  <div class="form-group">
                    <label class="col-form-label">Link</label><br>
                    {{offer.offerTrackingLink}}
                  </div>
              </div>
            </div>
          </div>

        </div>
        <div class="card-footer btn-showcase">
          <button class="btn btn-sm btn-pill btn-primary" type="button" ngbTooltip="return to offer list"
          (click)="onCancel()">Return</button>

          <button class="btn btn-sm btn-pill btn-primary" type="button" *ngIf="offer.offerGlobalStatus=='Expired'" disabled>Expired</button>
          <button class="btn btn-sm btn-pill btn-success" type="button" ngbTooltip="offer status on/off" *ngIf="offer.offerGlobalStatus=='Active' && offer.offerPublisherStatus=='Active'"
                (click)="onStatus()">Active</button>
          <button class="btn btn-sm btn-pill btn-danger" type="button" ngbTooltip="offer status on/off" *ngIf="offer.offerGlobalStatus=='Active' && offer.offerPublisherStatus=='Disabled'"
                (click)="onStatus()">Disabled</button>
        </div>
      </div>

    <!-- </div> -->
  </div>

<!-- Container-fluid Ends-->
